import { Injectable } from '@angular/core';
import { ErrorObject } from './gpiserror-object'
import { ErrorTypeEnum } from '../shared/enums.model';

@Injectable()
export class ErrorHandlerLogService {

    constructor() {}
    logErrorObject( errorObj: ErrorObject ) {
        // TODO log to DB or something else instead of console
        if ( errorObj.errType == ErrorTypeEnum.Error )
            console.log( errorObj.errorText );
        else if ( errorObj.errType == ErrorTypeEnum.Warning )
            console.log( errorObj.errorText );
        else if ( errorObj.errType == ErrorTypeEnum.Info )
            console.log( errorObj.errorText );
    }

    logError( error: any ) {
        console.log( error );
        // TODO log to DB or something else instead of console
    }
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/errorhandler/gpiserror-error-log.service.ts